export default __webpack_public_path__ + "static/media/FLECHITA.8902f315.svg";